import BlogList from '../components/BlogList'
import DonationCTA from '../components/DonationCTA'

export default function Blog() {
  return (
    <article>
      <div className="pt-32">
        <BlogList />
      </div>
      <div className="mb-40">
        <DonationCTA />
      </div>
    </article>
  )
} 